import React, { useState } from "react";
import { Input } from "@mui/material";
import CellMenu from "../TemplateDriven/CellMenu";
import { useDispatch, useSelector } from "react-redux";
import "./freeFrom.scss";
import {
  pageRedirection,
  setCellToUpdateToStore,
} from "../../../redux/processor/actions";
import { valiPageRedirection } from "../../../redux/validator/actions";
import { action } from "../../../constants/action";
import CellInfoMenu from "../TemplateDriven/CellInfoMenu";
import { setSelectedFileDataForProUpdateMapping } from "../../../redux/pre_processor/actions";
import ContextMenu from "../TemplateDriven/ContextMenu";
import { Divider } from "@mui/material";

// Create an editable cell renderer
const EditableCell = ({
  value: initialValue,
  row: { index },
  column: { id },
  updateMyData, // This is a custom function that we supplied to our table instance
  updateDataUsingManuallyContextMenu,
  showContextMenu,
  isDisableOnChangeInput,
  isDisableOnBlur,
  role,
  rejectCell,
  deleteRejection,
  markAsResolveByProcessor,
  reProcess,
  reValidate,
  data,
  isDataRejectedByProcessor,
  isDataRejectedByValidator,
  setCellToUpdateToState,
  clearMappings,
  entireBatchRejectedByPro,
  entireBatchRejectedByVali,
  reProcessEntireBatch,
  addLogsForMappingOnBlur,
  resestSelectedArea,
}) => {
  // We need to keep and update the state of the cell normally
  // const initialPointers = {
  //   mouseX: null,
  //   mouseY: null,
  // };
  const dispatch = useDispatch();
  const isTableSelection = useSelector((state) => state?.pro?.isTableSelection);

  const [value, setValue] = React.useState(initialValue);
  // const [pointers, setPointers] = React.useState(initialPointers);
  // const [dragToValues, setDragToValues] = useState(null);
  const [isOpemContextMenu, setIsOpemContextMenu] = useState(false);
  const [contextEvent, setContextEvent] = React.useState(null);
  const [parameterKey, setParameterKey] = React.useState(
    initialValue?.keyCoordinatesValues
      ? initialValue?.keyCoordinatesValues.join(" ")
      : ""
  );

  React.useEffect(() => {
    setParameterKey(
      initialValue?.keyCoordinatesValues
        ? initialValue?.keyCoordinatesValues.join(" ")
        : ""
    );
  }, [initialValue?.keyCoordinatesValues]);
  const onChange = (e) => {
    let value = e.target.value;
    const regex = /\n/g;
    value = value.replace(regex, "");
    setValue(value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = (string) => {
    if (role === "preProcessor") {
      addLogsForMappingOnBlur(index, id, string);
    }
    // disable when role is pre proceoosr
    if (!isDisableOnBlur && !isDisabled()) {
      if (
        initialValue?.fileNo &&
        initialValue?.pageNo &&
        initialValue?.tagName
      ) {
        dispatch(
          setSelectedFileDataForProUpdateMapping({
            fileNo: initialValue?.fileNo,
            pageNo: initialValue?.pageNo,
            tagName: initialValue?.tagName,
          })
        );
      }

      updateMyData({ rowIndex: index, columnId: id, value }); // here index = rowIndex and id = columnId
    }
  };

  const onCellClick = (string) => {
    if (role === "preProcessor") {
      updateMyData({ rowIndex: index, columnId: id, value, string }); // passing value nut not having any use
      setCellToUpdateToState({
        rowIndex: index,
        columnId: id,
        ...(string === "forParameterKey"
          ? { mappingFor: "parameterKey" }
          : { mappingFor: "parameterValue" }),
      });
    } else if (role === "processor" && !isDisabled()) {
      if (
        initialValue?.fileNo >= 0 &&
        initialValue?.pageNo >= 0 &&
        initialValue?.tagName
      ) {
        const { fileNo, tagName, pageNo, indexesOfCoordinates, coordinates } =
          initialValue;
        dispatch(
          pageRedirection({
            fileNo,
            tagName,
            pageNo,
            indexesOfCoordinates,
            coordinates,
          })
        );
      }
      if (!isDisabled()) {
        if (isTableSelection) {
          dispatch(setCellToUpdateToStore({ rowIndex: index, columnId: id }));
        } else setCellToUpdateToState({ rowIndex: index, columnId: id });
      } else {
        setCellToUpdateToState({ rowIndex: null, columnId: null });
      }
    } else if (role === "validator") {
      if (
        initialValue?.fileNo >= 0 &&
        initialValue?.pageNo >= 0 &&
        initialValue?.tagName
      ) {
        const { fileNo, tagName, pageNo, indexesOfCoordinates, coordinates } =
          initialValue;
        dispatch(
          valiPageRedirection({
            fileNo,
            tagName,
            pageNo,
            indexesOfCoordinates,
            coordinates,
          })
        );
      }
    }
    resestSelectedArea();
  };

  // for role === pro and vali role    // here we are showing actual values
  // If the initialValue is changed external, sync it up with our state
  React.useEffect(() => {
    if (role === "processor" || role === "validator") {
      // temp show tagging as it is later show value
      let valueToShow = "";
      if (initialValue?.value) {
        valueToShow = initialValue?.value;
      } else {
        valueToShow = "";
      }
      setValue(valueToShow);
    }
    if (role === "preProcessor") {
      let valueToShow = "";
      if (initialValue?.tagName && initialValue?.pageNo >= 0) {
        const pageNo = parseInt(initialValue?.pageNo) + 1; // added 1 because index starting from 0 and we want to shoe as 1
        valueToShow = `${initialValue?.tagName} - ${parseInt(pageNo)}`;
      } else {
        valueToShow = "";
      }
      setValue(valueToShow);
    }
  }, [initialValue?.value, initialValue?.pageNo, initialValue?.tagName, role]);

  const handleClick = (event) => {
    event.preventDefault();
    setContextEvent(event);
    setIsOpemContextMenu(true);
  };

  const handleCloseMenu = () => {
    // setPointers(initialPointers);
    // setDragToValues(null);
    setIsOpemContextMenu(false);
  };

  const isDisabled = () => {
    let isDisabled = false;

    if (role === "preProcessor") {
      if (
        isDataRejectedByProcessor === true && // getting true when data is rejected
        entireBatchRejectedByPro === false // getting true when entire batch rejected
      ) {
        isDisabled =
          initialValue?.processorCellRejection?.isRejected === true ||
          data[index]?.processorRowRejection?.isRejected === true
            ? false
            : true;
      } else if (
        isDataRejectedByProcessor === true && // getting both flags true when entire batch rejected
        entireBatchRejectedByPro === true
      ) {
        isDisabled = false;
      }
    }

    if (role === "processor") {
      if (entireBatchRejectedByVali) {
      }
      if (!entireBatchRejectedByVali) {
        if (!reProcessEntireBatch) {
          if (reProcess) {
            if (
              initialValue?.processorCellRejection?.isResolved ||
              data[index]?.processorRowRejection?.isResolved
            ) {
              isDisabled = false;
            } else isDisabled = true;
          }
        }

        if (isDataRejectedByValidator) {
          isDisabled =
            initialValue?.validatorCellRejection?.isRejected ||
            data[index]?.validatorRowRejection?.isRejected
              ? false
              : true;
        }

        if (reProcess && isDataRejectedByValidator) {
          // when data rejected by validator and processor and then resolved by pre processor at that time for both rejection we need to enable field
          let disableForProResolve = !(
            initialValue?.processorCellRejection?.isResolved === true ||
            data[index]?.processorRowRejection?.isResolved
          );
          let disableForValidatorRejection =
            initialValue?.validatorCellRejection?.isRejected ||
            data[index]?.validatorRowRejection?.isRejected
              ? false
              : true;

          if (
            disableForProResolve === false &&
            disableForValidatorRejection === true
          ) {
            isDisabled = false;
          }
        }
      }
    }
    if (role === "validator") {
      isDisabled = true;
      if (reValidate) {
        isDisabled = !(
          initialValue?.validatorCellRejection?.isResolved === true ||
          data[index]?.validatorRowRejection?.isResolved
        );
      } else isDisabled = false;
    }
    return isDisabled;
  };

  const styleRejectedCell = () => {
    let backgroundColor = "var(--bg-white)";

    if (role === "preProcessor") {
      if (
        initialValue?.processorCellRejection?.isRejected ||
        data[index]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(255 137 116)"; // fent red
      }
      if (
        initialValue?.processorCellRejection?.isRejected &&
        data[index]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
        // dark red
      }
    }

    if (role === "processor") {
      // if cell or row rej in vali  or pro
      if (
        initialValue?.processorCellRejection?.isRejected ||
        data[index]?.processorRowRejection?.isRejected ||
        initialValue?.validatorCellRejection?.isRejected ||
        data[index]?.validatorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(255 137 116)";
        // fent red
      }
      // if cell and row rej in pro
      if (
        initialValue?.processorCellRejection?.isRejected &&
        data[index]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
        // dark red
      }
      // if cell and row rej in vali
      if (
        initialValue?.validatorCellRejection?.isRejected &&
        data[index]?.validatorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
        // dark red
      }
      // if cell and row rej in vali ans coll or row rej in pro

      if (
        (initialValue?.validatorCellRejection?.isRejected ||
          data[index]?.validatorRowRejection?.isRejected) &&
        (initialValue?.processorCellRejection?.isRejected ||
          data[index]?.processorRowRejection?.isRejected)
      ) {
        backgroundColor = "rgb(255 75 46)";
        // 2* dark red
      }
      if (
        initialValue?.validatorCellRejection?.isRejected &&
        data[index]?.validatorRowRejection?.isRejected &&
        initialValue?.processorCellRejection?.isRejected &&
        data[index]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(255 75 46)"; // 3* dark red
      }
      // for resolved and Pro want to see comment'
      if (
        initialValue?.processorCellRejection?.isResolved ||
        data[index]?.processorRowRejection?.isResolved
      ) {
        backgroundColor = "#c6ff86";
      }
      if (
        initialValue?.processorCellRejection?.isResolved &&
        data[index]?.processorRowRejection?.isResolved
      ) {
        backgroundColor = "#c6ff86";
      }
    }

    if (role === "validator") {
      if (
        initialValue?.validatorCellRejection?.isRejected ||
        data[index]?.validatorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(255 137 116)";
        // fent red
      }
      if (
        initialValue?.validatorCellRejection?.isRejected &&
        data[index]?.validatorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
        // dark red
      }
      if (data[index]?.rowValidation?.isValidated) {
        backgroundColor = "#e5ffdb";
      }

      // for resolved and vali want to see comment'
      if (
        initialValue?.validatorCellRejection?.isResolved ||
        data[index]?.validatorRowRejection?.isResolved
      ) {
        backgroundColor = "#c6ff86";
      }
      if (
        initialValue?.validatorCellRejection?.isResolved &&
        data[index]?.validatorRowRejection?.isResolved
      ) {
        backgroundColor = "#c6ff86";
      }
    }

    return { backgroundColor: backgroundColor };
  };

  const onCero = (e, type) => {
    if (e.keyCode === 8 || e.keyCode === 46) {
      // key code added for backspace and delete
      clearMappings(index, id, type);
    }
  };

  const isDisableInfoIcon = (
    isDataRejectedByProcessor,
    cellRejected,
    rowRejected,
    isDataRejectedByValidator,
    valiCellRejected,
    valiRowRejected
  ) => {
    let isDisable = false;

    if (role === "preProcessor") {
      if (isDataRejectedByProcessor) {
        isDisable = true;
        if (cellRejected || rowRejected) {
          isDisable = false;
        }
      }
    } else if (role === "processor") {
      if (isDataRejectedByValidator) {
        isDisable = true;
        if (valiCellRejected || valiRowRejected) {
          isDisable = false;
        }
      }
    }

    return isDisable;
  };

  return (
    <div
      className="reject-resould-btn"
      onContextMenu={
        showContextMenu
          ? (e) => {
              handleClick(e);
            }
          : undefined
      }
      style={styleRejectedCell()}
    >
      <div className="reject-resould-div">
        {role === "preProcessor" && (
          <>
            <div style={{ flex: 1 }}>
              <Input
                onKeyDown={
                  role === "preProcessor"
                    ? (e) => onCero(e, "toResetKeyMapping")
                    : undefined
                }
                className={`${
                  isDisabled()
                    ? "disableCell w-100"
                    : role === "validator"
                      ? "disable_opacity w-100"
                      : "w-100"
                }`}
                type="string"
                variant="outlined"
                onBlur={() =>
                  !isDisabled() ? onBlur("parameterKeyMapping") : undefined
                }
                onClick={(event) =>
                  !isDisabled() ? onCellClick("forParameterKey") : undefined
                }
                contentEditable={true}
                value={parameterKey !== undefined ? parameterKey : ""}
                multiline={true}
                suppressContentEditableWarning={true}
                disabled={isDisabled()}
                placeholder={role === "preProcessor" ? "Parameter" : ""}
              />
            </div>
            <Divider variant="middle" className="dividerN" />
          </>
        )}

        <div>
          <Input
            onKeyDown={
              role === "preProcessor"
                ? (e) => {
                    onCero(e, "toResetValueMapping");
                  }
                : undefined
            }
            className={`${
              isDisabled()
                ? "disableCell w-100"
                : role === "validator"
                  ? "disable_opacity w-100"
                  : "w-100"
            }`}
            type="string"
            variant="outlined"
            onChange={!isDisableOnChangeInput ? onChange : undefined}
            onBlur={() => onBlur("parameterKeyMapping")}
            onClick={(event) => onCellClick("forParameterValue")}
            contentEditable={true}
            value={value !== undefined ? value : ""}
            multiline={true}
            suppressContentEditableWarning={true}
            disabled={isDisabled()}
            placeholder={role === "preProcessor" ? "Value" : ""}
          />
        </div>
      </div>

      {((initialValue?.coordinatesValues &&
        initialValue?.coordinatesValues.length > 0) ||
        (initialValue?.keyCoordinatesValues &&
          initialValue?.keyCoordinatesValues.length > 0)) &&
        role !== "validator" && (
          <CellInfoMenu
            coordinatesValues={initialValue?.coordinatesValues}
            keyCoordinatesValues={initialValue?.keyCoordinatesValues}
            clearMappings={(type) => clearMappings(index, id, type)}
            //  true to disable false to enable
            isDisable={isDisableInfoIcon(
              isDataRejectedByProcessor,
              initialValue?.processorCellRejection?.isRejected,
              data[index]?.processorRowRejection?.isRejected,
              isDataRejectedByValidator,
              initialValue?.validatorCellRejection?.isRejected,
              data[index]?.validatorRowRejection?.isRejected
            )}
            role={role}
            // common function used for clear mapings from cell menu and using backspace and delete buttom
          />
        )}

      {((role === "preProcessor" &&
        initialValue?.processorCellRejection?.isRejected === true) ||
        role === "processor" ||
        role === "validator") && (
        <CellMenu
          isRejectedByProcessor={
            initialValue?.processorCellRejection?.isRejected
          }
          processorRejectionRemark={
            initialValue?.processorCellRejection?.remark
          }
          isRejectedByValidator={
            initialValue?.validatorCellRejection?.isRejected
          }
          validatorRejectionRemark={
            initialValue?.validatorCellRejection?.remark
          }
          rejectCell={(rejectionRemark) =>
            rejectCell({ rejectionRemark, rowIndex: index, columnId: id })
          }
          deleteRejection={() =>
            deleteRejection({ rowIndex: index, columnId: id })
          }
          role={role}
          markAsResolveByProcessor={() =>
            markAsResolveByProcessor({ rowIndex: index, columnId: id })
          }
          isRwoValidated={data[index]?.rowValidation?.isValidated}
          heading={
            role === "preProcessor"
              ? action.REJECTION_REMARK
              : action.REJECTION_PROMPT
          }
          isResolvedProcessorCellRejection={
            initialValue?.processorCellRejection?.isResolved
          }
          isResolvedValidatorCellRejection={
            initialValue?.validatorCellRejection?.isResolved
          }
        />
      )}

      <ContextMenu
        showContextMenu={showContextMenu}
        isOpemContextMenu={isOpemContextMenu}
        handleCloseMenu={handleCloseMenu}
        updateDataUsingManuallyContextMenu={updateDataUsingManuallyContextMenu}
        // dragInTo={dragInTo}
        parameterIndex={index}
        mappingIndex={id}
        contextEvent={contextEvent}
      />
    </div>
  );
};

export default EditableCell;
